/* Einladungen: fester Typenkatalog, geteilt zwischen Liste und Formular. */

export const INVITE_TYPES = ['nationalCamp', 'clubInvitation'];

/* Rollen, die beim Einladen eines Nutzers vergeben werden dürfen (Zugangsanfragen).
   'admin' gehört bewusst nicht dazu — das geschieht in der Nutzerverwaltung. Die Edge
   Function invite-user führt dieselbe Liste (supabase/functions/invite-user/decision.ts);
   ein Test vergleicht beide. */
export const INVITE_ROLES = ['guest', 'staff', 'data', 'board'];
export const DEFAULT_INVITE_ROLE = 'guest';
